// extracted by mini-css-extract-plugin
export default {"list":"RadioGroup_list__Q8zWV","mobileModal":"RadioGroup_mobileModal__f21o3","item":"RadioGroup_item__pPgB-"};